import PetForms from "../../components/organisms/Pet-Insurance/form";
const PetInsuranceFormsPage = (props) => {

  return (
    <PetForms sendGTM={props.sendGTM} />
  );
};

export default PetInsuranceFormsPage;
